import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=53239e4e"
import script from "./FloatingActionButton.vue?vue&type=script&lang=ts"
export * from "./FloatingActionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports